module.exports = __webpack_public_path__ + "img/douyin_tixian.181d4ce3.png";